/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import ApiService from 'cio/services/api';
import ApiErrorsService from 'cio/services/api-errors';
import DS from 'ember-data';
import LayoutModel from 'cio/models/layout';
import { tracked } from '@glimmer/tracking';

interface LayoutsGridArgs {
  pageResults: LayoutModel[];
  model: LayoutModel[];
}

export default class LayoutsGrid extends Component<LayoutsGridArgs> {
  @service api!: ApiService;
  @service apiErrors!: ApiErrorsService;
  @service store!: DS.Store;

  @tracked showSetDefaultModal = false;

  @tracked newDefaultLayout: LayoutModel | null = null;

  get currentDefault() {
    return this.args.model.findBy('isDefault', true);
  }

  setDefault = task({ drop: true }, async () => {
    let { newDefaultLayout } = this;

    if (newDefaultLayout == null) {
      return;
    }

    let { id } = newDefaultLayout;
    let promise = this.api.post(`layouts/${id}/default`, { data: {} });

    this.apiErrors.attach(promise);

    let response = await promise;

    if (this.currentDefault != null) {
      this.currentDefault.set('isDefault', false);
    }

    this.store.pushPayload(response);
    this.showSetDefaultModal = false;
  });

  @action
  showModal(layout: LayoutModel) {
    this.newDefaultLayout = layout;
    this.showSetDefaultModal = true;
  }

  @action
  closeModal() {
    this.newDefaultLayout = null;
    this.showSetDefaultModal = false;
  }
}
